// Where clicking a notification (bell dropdown or toast) should take the user.
const TYPE_ROUTE = {
  ic3_alert: '/dashboard/fraud-alerts',
  psa_alert: '/dashboard/fraud-alerts',
  hot_scam: '/dashboard/fraud-alerts?tab=hot-scams',
  domain_alert: '/dashboard/sci-report',
  rank_digest: '/dashboard/sci-report',
  login_alert: '/dashboard/account-management',
  billing: '/dashboard/account-management',
};

// Notification types whose payload names a specific alert.
const ALERT_TYPES = ['ic3_alert', 'psa_alert'];

/**
 * payload.url (internal path or external https) wins; then a deep link to the
 * specific alert; then the per-type landing page; then the hub.
 *
 * Alert notifications carry ic3_alert_id, so they now resolve to that alert's
 * own page. Landing on the list instead left the reader hunting for the alert
 * they had just been told about — and the list only renders one source tab at a
 * time, so an SSA, IRS or FTC alert would not even have been on screen.
 */
export function routeForNotification(n) {
  const payload = (n && n.payload) || {};
  if (payload.url) return payload.url;

  // A hot scam page is addressed by slug.
  if (n && n.type === 'hot_scam' && payload.hot_scam_slug) {
    return `/dashboard/hot-scams/${payload.hot_scam_slug}`;
  }

  const alertId = payload.ic3_alert_id;
  if (alertId && ALERT_TYPES.includes(n && n.type)) {
    return `/dashboard/fraud-alerts/${alertId}`;
  }

  return (n && TYPE_ROUTE[n.type]) || '/dashboard/notifications';
}
